<div [formGroup]="form_group">
  <div class="table-responsive" *ngIf="masters[field.masterPropName] && masters[field.masterPropName].length">
    <table class="table table-striped">
      <thead>
        <th class="col-md-6 col-width-100">
          {{ "ALERT.questions" | translate }}
        </th>
        <th class="col-md-3">
          {{ "ALERT.response" | translate }}
        </th>


      </thead>
      <tbody>
        <ng-container [formArrayName]="field.fieldID"
          *ngFor="let question of form_group.get(field.fieldID)['controls']; let i = index;">
          <tr [formGroupName]="i">
            <td style="white-space: normal !important; vertical-align: middle;" [title]="question.title">
              <span class="multi-line-truncate-2">
                {{masters[field.masterPropName][i].title | translate}}
              </span>
            </td>
            <td style="vertical-align: middle;" *ngIf="masters[field.masterPropName][i].optionType == 1">
              <mat-radio-group formControlName="selectedOptionCode">
                <mat-radio-button class="mx-1" *ngFor="let item of masters[field.masterPropName][i].options"
                  [value]="item.optionCode">
                  {{item.title | translate}}
                </mat-radio-button>
              </mat-radio-group>
            </td>
            <td *ngIf="masters[field.masterPropName][i].optionType == 2">
              <input type="text" class="form-control" formControlName="inputAnswerOne" />
            </td>

            <td *ngIf="masters[field.masterPropName][i].optionType == 2">
              <input type="text" class="form-control" formControlName="inputAnswerTwo" />
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
